const HIDDEN_MANUAL_ORDER_PRODUCT_SKUS = new Set([
  'fc5mesi',
  'fc8mesi',
]);

const normalizedSku = product => String(
  product?.sku || product?.productSku || product?.woo?.sku || ''
).trim().toLowerCase();

export function isManualOrderProductVisible(product) {
  return !HIDDEN_MANUAL_ORDER_PRODUCT_SKUS.has(normalizedSku(product));
}

export function manualOrderProductOptions(products = []) {
  return Array.isArray(products) ? products.filter(isManualOrderProductVisible) : [];
}

